<div class="research-popup {{partnerName}}">
    <input type="file" id="research-file-input" style="opacity:0; visibility:hidden;height:0px;width:0px;position:absolute;z-index:-1;" (change)="handelResearchFile($event)" />
    <as-split #mainSplitter [unit]="'pixel'">
        <as-split-area [size]="220">
            <div class="research-statistics scrollbar-white" [style.height.px]="chartContainerHeight">
                <div class="filter-block" [class.filter-disabled]="selectedTab === TabsEnum.SELECTED || !researchData.length">
                    <div class="filter-title"><span>Filter</span> <span>(double click on a line in the keywords chart below to add a keyword filter)</span></div>
                    <div class="filter-switch">
                        <ul>
                            <li>OR</li>
                            <li>
                                <div class="switch-button" [class.active]="selectedSwitch === SwitchEnum.AND" (click)="fnSwitchToggle()"></div>
                            </li>
                            <li>AND</li>
                        </ul>
                    </div>
                    <div class="filter-content">
                        <ul *ngIf="publicationFilterArray.length">
                            <li *ngFor="let item of publicationFilterArray;let i=index">
                                <div>{{item}}</div>
                                <span (click)="fnRemoveToPublicationFilter(i)">&times;</span>
                            </li>
                        </ul>
                        <ul *ngIf="keywordFilterArray.length">
                            <li *ngFor="let item of keywordFilterArray;let i=index">
                                <div>{{item}}</div>
                                <span (click)="fnRemoveToKeywordFilter(i)">&times;</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <ng-template #htmlTooltip>
                    <div class="chart-item">{{chartTooltip.category}}</div>
                    <div class="chart-item">Value: <span>{{chartTooltip.value}}</span></div>
                </ng-template>
                <div class="chart-block-heading">
                    <span class="expand-icon" [class.expanded]="showPublications" (click)="showPublications=!showPublications">
                        <img src="/images/icons/triangle/down-arrow.svg" alt="down-arrow.svg" />
                        <img src="/images/icons/triangle/right-arrow.svg" alt="right-arrow.svg" />
                    </span>
                    <span>Publication Types</span>
                </div>
                <div class="chart-block publications" *ngIf="showPublications">
                    <dl>
                        <ng-container *ngFor="let data of publicationChartData">
                            <dd class="percentage percentage-{{data.percentage}}" placement="right" container="body" [ngbTooltip]="htmlTooltip" tooltipClass="chart-tooltip {{partnerName}}" (mouseenter)="chartTooltip=data" (mouseleave)="chartTooltip={}" (dblclick)="fnAddToPublicationFilter(data.category)">
                                <span class="text">{{data.category}}</span>
                            </dd>
                        </ng-container>
                    </dl>
                </div>
                <div class="chart-block-heading">
                    <span class="expand-icon" [class.expanded]="showKeywords" (click)="showKeywords=!showKeywords">
                        <img src="/images/icons/triangle/down-arrow.svg" alt="down-arrow.svg" />
                        <img src="/images/icons/triangle/right-arrow.svg" alt="right-arrow.svg" />
                    </span>
                    <span>Keywords</span>
                </div>
                <div class="chart-block" *ngIf="showKeywords">
                    <dl>
                        <ng-container *ngFor="let data of keywordChartData">
                            <dd class="percentage percentage-{{data.percentage}}" placement="right" container="body" [ngbTooltip]="htmlTooltip" tooltipClass="chart-tooltip {{partnerName}}" (mouseenter)="chartTooltip=data" (mouseleave)="chartTooltip={}" (dblclick)="fnAddToKeywordFilter(data.category)">
                                <span class="text">{{data.category}}</span>
                            </dd>
                        </ng-container>
                    </dl>
                </div>
            </div>
        </as-split-area>
        <as-split-area>
            <div class="research-container">
                <div id="research-top-section">
                    <div class="research-heading">
                        <div class="title">
                            <input type="text" [(ngModel)]="queryName" placeholder="New Query" (keyup)="fnUpdateJsPanelTitle()" (change)="fnUpdateJsPanelTitle()" />
                            <ul>
                                <li placement="bottom" ngbTooltip="Load" (click)="onLoad()">
                                    <img src="/images/icons/Load.svg" alt="Load" />
                                </li>
                                <li placement="bottom" ngbTooltip="Save" (click)="onDownload()">
                                    <img src="/images/icons/Save.svg" alt="Save" />
                                </li>
                            </ul>
                        </div>
                        <div class="search-block">
                            <textarea [(ngModel)]="searchQuery" class="form-control" placeholder="Enter text to search..." rows="2" (keyup)="fnChangeSearchQuery()"></textarea>
                            <button type="button" class="input-button selected" (click)="fetchAPIData()"><span>Search</span></button>
                        </div>
                    </div>
                    <div class="research-suggestions scrollbar-white">
                        <div class="input-buttons">
                            <ng-container *ngFor="let option of suggestedOptions">
                                <button type="button" class="input-button" [class.selected]="option.Selected" (click)="bindToQuery(option)">
                                    <span>{{option.Label}}</span>
                                </button>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="research-tabs">
                    <ul>
                        <li [class.active]="selectedTab===TabsEnum.RESULTS" (click)="fnTabChange(TabsEnum.RESULTS)">Results</li>
                        <li [class.active]="selectedTab===TabsEnum.SELECTED" (click)="fnTabChange(TabsEnum.SELECTED)">Selected</li>
                    </ul>
                    <div class="tab-content">
                        <div class="absolute-loading" *ngIf="showLoader">
                            <div class="lds-ripple"><div></div><div></div></div>
                        </div>
                        <div *ngIf="selectedTab===TabsEnum.RESULTS">
                            <as-split #summarySplitter [unit]="'percent'">
                                <as-split-area [size]="summaryRowData?60:100">
                                    <div id="researchGrid" class="research-grid"></div>
                                    <div class="load-new-buffer-data" *ngIf="showBufferButton" (click)="fnLoadNextBufferData()">
                                        <span>+</span>
                                    </div>
                                </as-split-area>
                                <as-split-area [size]="40" *ngIf="summaryRowData">
                                    <div class="summery-content scrollbar-white" [style.height.px]="cardBodyHeight">
                                        <div *ngIf="summaryRowData?.title"><strong>Title:</strong> {{summaryRowData.title}}</div>
                                        <div *ngIf="summaryRowData?.date"><strong>Date:</strong> {{summaryRowData.date}}</div>
                                        <div *ngIf="summaryRowData?.url"><strong>Link:</strong> <a href="{{summaryRowData.url}}" target="_blank">{{summaryRowData.url}}</a></div>
                                        <div *ngIf="summaryRowData?.publication_types?.length"><strong>Publication Types:</strong> {{summaryRowData.publication_types.join(', ')}}</div>
                                        <div *ngIf="summaryRowData?.keywords?.length"><strong>Keywords:</strong> {{summaryRowData.keywords.join(', ')}}</div>
                                        <div *ngIf="summaryRowData?.mesh_terms?.length"><strong>Mesh Terms:</strong> {{summaryRowData.mesh_terms.join(', ')}}</div>
                                        <hr *ngIf="summaryRowData?.abstract" />
                                        <div class="abstract" *ngIf="summaryRowData?.abstract">{{summaryRowData.abstract}}</div>
                                    </div>
                                </as-split-area>
                            </as-split>
                        </div>
                        <div class="research-cards scrollbar-white" [style.height.px]="cardBodyHeight" *ngIf="selectedTab===TabsEnum.SELECTED">
                            <app-research-cards [researchCards]="researchCards"></app-research-cards>
                        </div>
                    </div>
                </div>
            </div>
        </as-split-area>
    </as-split>
</div>
